var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-manage"},[_c('sn-table',{attrs:{"headers":_vm.headers,"tableData":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }